import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

const alignCenterValues = ['H', 'BOTH'];
const justifyCenterValues = ['V', 'BOTH'];

const Row = ({ children, center='', align='', className='', name='', style={} }) => {
  let fullClassName = classNames('flex-row', {
    'align-center': _.includes(alignCenterValues, center.toUpperCase()),
    'justify-center': _.includes(justifyCenterValues, center.toUpperCase()),
    'justify-start': align === 'LEFT',
    'justify-end': align === 'RIGHT',
    'spc-between': align === 'SPREAD',
  });

  if (className) {
    fullClassName += ` ${className}`;
  }

  return (
    <div className={fullClassName} name={name} data-name="Row" style={style}>{children}</div>
  );
};

Row.propTypes = {
  center: PropTypes.oneOf(['H', 'V', 'BOTH']),
  align: PropTypes.oneOf(['LEFT', 'RIGHT', 'SPREAD']),
  className: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.any,
  style: PropTypes.object
};

export default Row;
